import React from 'react';
import {
  Route, Routes,
} from 'react-router-dom';
import AccountPage from './pages/AccountPage/AccountPage';
import HomePage from './pages/HomePage/HomePage';
import OrariPage from './pages/OrariPage/OrariPage';
import ServiziPage from './pages/ServiziPage/ServiziPage';
import PoltronePage from './pages/PoltronePage/PoltronePage';
import RiepilogoPage from './pages/RiepilogoPage/RiepilogoPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/orari" element={<OrariPage />} />
      <Route path="/servizi" element={<ServiziPage />} />
      <Route path="/poltrone" element={<PoltronePage />} />
      <Route path="/riepilogo" element={<RiepilogoPage />} />
    </Routes>
  );
}

export default App;
